import { readJson, rememberValue, userKey } from "../../browserMemory.js";
import { DUE_SOURCES, isDueSource, OFFERED_SOURCES } from "./dueItems.js";
import type { DueSource } from "./dueItems.js";

/**
 * GEDÄCHTNIS DER QUELLENWAHL (Spec D22, Plan T17): eine Wahl je Benutzer für Liste, Zeitachse und Kalender, im Browser
 * unter `ki-due-sources:<userId>` (Bequemlichkeit des Geräts, keine Einstellung des Kontos). Gemerkt werden nur
 * Quellnamen in der Quellenfolge; Unbekanntes fällt weg. Vorgabe: Tickets und Meilensteine an, Fremdquellen aus — Board,
 * Liste und Zeitachse sehen nach dem Release aus wie vorher, bis jemand zuschaltet.
 *
 * Gelesen wird nur, was heute angeboten ist (`OFFERED_SOURCES`; „Meilensteine“ erst ab Stufe B). Eine noch nicht
 * angebotene Quelle der Wahl (aus der Vorgabe oder gemerkt) bleibt beim Merken stehen — sonst wäre „Meilensteine an“ für
 * jeden verloren, der in Stufe A einen Chip umgeschaltet hat.
 */

const KEY = "ki-due-sources";
const DEFAULT: readonly DueSource[] = ["TICKET", "MILESTONE"];

const inOrder = (s: readonly DueSource[]): DueSource[] => DUE_SOURCES.filter((d) => s.includes(d));

/** Die ganze Wahl: gemerkt (nur bekannte Quellen) oder die Vorgabe. */
function stored(userId: string): DueSource[] {
  const remembered = readJson(userKey(KEY, userId));
  return Array.isArray(remembered) ? inOrder(remembered.filter((x): x is DueSource => typeof x === "string" && isDueSource(x)))
    : [...DEFAULT];
}

export function readDueSources(userId: string): DueSource[] {
  return stored(userId).filter((s) => OFFERED_SOURCES.includes(s));
}

export function rememberDueSources(userId: string, s: readonly DueSource[]): void {
  const hidden = stored(userId).filter((d) => !OFFERED_SOURCES.includes(d));
  rememberValue(userKey(KEY, userId), JSON.stringify(inOrder([...s.filter((d) => OFFERED_SOURCES.includes(d)), ...hidden])));
}
